import { FaGlobe } from "react-icons/fa";
import { featureToggles, imageWithAlt } from "../objects";
import { page } from ".";
import { defineType } from "sanity";

export default defineType({
  name: "site",
  title: "Site",
  icon: FaGlobe,
  type: "document",
  fieldsets: [
    {
      name: "featureToggles",
      title: "Feature Toggles"
    },
    {
      name: "menu",
      title: "Main Menu",
      options: { collapsible: true, collapsed: true }
    },
    {
      name: "redirects",
      title: "Redirects",
      options: { collapsible: true, collapsed: true }
    }
  ],
  fields: [
    {
      title: "Feature Toggles",
      name: "featureToggles",
      description: "Features to be toggled off on live until sign-off",
      type: featureToggles.name
    },
    {
      title: "Open graph",
      name: "openGraph",
      description:
        "These will be the default meta tags on all pages that have not set their own",
      type: "openGraph",
      options: {
        collapsed: true,
        collapsable: true
      }
    },
    {
      fieldset: "menu",
      name: "footerMenuGroups",
      title: "Footer Menu Groups",
      type: "array",
      of: [{ type: "menuGroup" }]
    },
    {
      title: "Default Port Image",
      name: "defaultPortImage",
      type: imageWithAlt.name
    },
    {
      name: "worldCruisesPage",
      title: "World Cruises Page",
      type: "reference",
      to: [{ type: page.name }],
      validation: (Rule) => Rule.required(),
      readOnly: true
    },
    {
      name: "grandVoyagesPage",
      title: "Grand Voyages Page",
      type: "reference",
      to: [{ type: page.name }],
      validation: (Rule) => Rule.required(),
      readOnly: true
    },
    {
      name: "termsAndConditionsExternalPage",
      title: "Terms and Conditions External Page",
      type: "string",
      description: "URL to the royal's page for terms and conditions"
    }
  ],
  preview: {
    prepare(value) {
      return {
        title: "Site"
      };
    }
  }
});
